// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// function Navbar() {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     axios.post(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {}, { withCredentials: true })
//       .then(() => {
//         navigate("/");
//         window.location.reload();
//       })
//       .catch((err) => console.error("Errore logout:", err));
//   };

//   return (
//     <header className="header">
//       <div className="header_logo">
//         <div className="logo_img"></div>
//         <div className="logo_wrt"></div>
//       </div>
//       <nav className="header_menu">
//         <a href="dashboard.html">Dashboard</a>
//         <a href="registry.html">Anagrafiche</a>
//         <a href="statistics.html">Statistiche</a>
//         <a href="notifications.html">Notifiche</a>
//         <a href="settings.html">Impostazioni</a>
//         <a href="profile.html">Profilo</a>
//         <button id="button_logout" onClick={handleLogout}>Logout</button>
//       </nav>
//     </header>
//   );
// }

// export default Navbar;

// _______________________________________________________________________________________________________________

import { useNavigate } from "react-router-dom";
import { logoutUser } from "../api";

function Navbar() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    logoutUser()
      .then(() => {
        navigate("/");
        window.location.reload();
      })
      .catch((err) => console.error("Errore logout:", err));
  };

return (
  <header className="header">
    <div className="header_logo">
      <div className="logo_img"></div>
      <div className="logo_wrt"></div>
    </div>
    <nav className="header_menu">
      <button onClick={() => handleNavigation("/dashboard")}>Dashboard</button>
      <button onClick={() => handleNavigation("/registry")}>Anagrafiche</button>
      <button onClick={() => handleNavigation("/statistics")}>Statistiche</button>
      <button onClick={() => handleNavigation("/notifications")}>Notifiche</button>
      <button onClick={() => handleNavigation("/settings")}>Impostazioni</button>
      <button onClick={() => handleNavigation("/profile")}>Profilo</button>
      <button onClick={handleLogout}>Logout</button>
    </nav>
  </header>
);
}

export default Navbar;